export default "__VITE_ASSET__SJZWT0D8__";